import React from 'react';
import useReveal from '../../AIEmployees/useReveal';
import WallFrame from '../../AIEmployees/sections/WallFrame';

/**
 * SAAvatars — the avatar feature on /super-agents.
 *
 * Since Sep 1 2026 (Nitish's ruling) this section renders the SAME Avatars
 * frame as the /ai-employees wall via WallFrame (picked by its frame class), instead of its
 * own older copy: one source, so every wall fix (12s snap-cut timeline,
 * preloaded chat + speaking tile, mobile tile flow) lands on both pages at
 * once. Section head + caption stay this page's own copy. The old bespoke
 * frame + SAAvatars.css are retired.
 */
const SAAvatars = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-av aie-section">
      <div className="aie-section-head">
        <span className="aie-eyebrow">Avatars</span>
        <h2 className="aie-section-title aie-display">Your face. Your voice. On demand.</h2>
        <p className="aie-section-sub">
          Create your avatar once: a name, a few photos, a short voice sample. From
          then on, one prompt produces videos, images, and narration that star you.
        </p>
      </div>
      <div className={`sa-av__reveal aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        <WallFrame cls="wm-av" />
      </div>
      <p className="aie-caption">
        <strong>Set it up once, use it everywhere.</strong>{' '}
        Videos, thumbnails, and narration that star you, from a single prompt.
      </p>
    </section>
  );
};

export default SAAvatars;
